import { StringUtil } from '@ddt-web/generic-utils';

declare const Highcharts;

/**
 * AreaSplineCurrencyTooltip: this tooltip includes both the currency value of the data point.
 */
export class AreaSplineCurrencyTooltip {
	public static getFormatter(displayCurrency: string = '$', customData: { header?: string; subHeader?: string }): Function {
		return function (): string {
			let out = '';
			let setTooltipHeader = true;
			const headerString = customData?.header;
			const subHeaderString = customData?.subHeader;
			out += '<div class="area-spline-tooltip-container">';
			this?.points?.forEach((point, index) => {
				const base = point.point?.baseValue ?? 1;
				const percentage = Highcharts.numberFormat((point.y * 100) / base, 1, '.', ',');
				if (setTooltipHeader) {
					out += `<h4 class="bold">${headerString}</h4>
								<h1 class="bold padding-top">-${percentage}%</h1>
								<h4 class="area-spline-tooltip-header">${subHeaderString + Highcharts.dateFormat('%b %e, %Y', this.x)}</h4>`;
					setTooltipHeader = false;
				}

				const seriesColor = point.series.color;
				out += `<div class="area-spline-tooltip"><table>
						<tr>
						<td colspan="2"><div class="portfolio-icon" style="background-color:
						${seriesColor};border-radius:50%; width:10px; height:10px; display:inline-block; margin-right:2px;"></div>
						${StringUtil.splitSpaceLessStringForChart(point.point.series.name, 50, true)}
						</td><td class="dollar-value">
						${displayCurrency} 
						${index === 1 ? Highcharts.numberFormat(point.y, 2, '.', ',') : Highcharts.numberFormat(point.total, 2, '.', ',')}
						</td>
						</tr>
					</table></div>`;
			});
			out += '</div>';
			return out;
		};
	}
}
